import { render, staticRenderFns } from "./FavouriteBtn.vue?vue&type=template&id=e8a7f016&scoped=true&"
import script from "./FavouriteBtn.vue?vue&type=script&lang=js&"
export * from "./FavouriteBtn.vue?vue&type=script&lang=js&"
import style0 from "./FavouriteBtn.vue?vue&type=style&index=0&id=e8a7f016&lang=scss&scoped=true&"
import style1 from "./FavouriteBtn.vue?vue&type=style&index=1&id=e8a7f016&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8a7f016",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e8a7f016')) {
      api.createRecord('e8a7f016', component.options)
    } else {
      api.reload('e8a7f016', component.options)
    }
    module.hot.accept("./FavouriteBtn.vue?vue&type=template&id=e8a7f016&scoped=true&", function () {
      api.rerender('e8a7f016', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/FavouriteBtn/FavouriteBtn.vue"
export default component.exports